import { supabase } from '../lib/supabase';

class DashboardService {
  async getFinancialSummary(month, year) {
    try {
      const { data: { user } } = await supabase?.auth?.getUser();
      if (!user) throw new Error('Not authenticated');

      const startDate = new Date(Date.UTC(year, month, 1))?.toISOString();
      const endDate = new Date(Date.UTC(year, month + 1, 0, 23, 59, 59))?.toISOString();

      const { data, error } = await supabase?.from('transactions')?.select('amount, type')?.gte('date', startDate)?.lte('date', endDate);
      
      if (error) throw error;

      const income = data?.filter(t => t?.type === 'income')?.reduce((sum, t) => sum + parseFloat(t?.amount), 0);
      
      const expense = Math.abs(
        data?.filter(t => t?.type === 'expense' || t?.type === 'payment')?.reduce((sum, t) => sum + parseFloat(t?.amount), 0)
      );

      return {
        income,
        expense,
        net: income - expense,
        transactionCount: data?.length
      };
    } catch (error) {
      console.error('Error fetching financial summary:', error);
      throw error;
    }
  }

  async getRecentActivity(limit = 6) {
    try {
      const { data, error } = await supabase?.from('transactions')?.select(`
          *,
          category:categories(name)
        `)?.order('date', { ascending: false })?.limit(limit);
      
      if (error) throw error;
      
      return data?.map(row => ({
        id: row?.id,
        description: row?.description,
        category: row?.category?.name || 'Uncategorized',
        type: row?.type,
        amount: Math.abs(parseFloat(row?.amount)),
        date: new Date(row.date)
      }));
    } catch (error) {
      console.error('Error fetching recent activity:', error);
      throw error;
    }
  }
}

export const dashboardService = new DashboardService();